"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldFileTool = exports.ModelMutatorFileTool = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var collection_field_1 = require("../collection.field");
var ModelMutatorFileTool = /** @class */ (function (_super) {
    tslib_1.__extends(ModelMutatorFileTool, _super);
    function ModelMutatorFileTool() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModelMutatorFileTool.prototype.manual = function (newFileTool) {
        if (newFileTool == null) {
            this.state.setFieldValue(this.field.id, null);
        }
        else {
            this.state.setFieldValue(this.field.id, {
                filename: newFileTool.filename,
                attachmentId: newFileTool.attachmentId,
                size: newFileTool.size,
                metadata: newFileTool.metadata
            });
        }
    };
    ModelMutatorFileTool.prototype.copy = function (from) {
        return false;
    };
    return ModelMutatorFileTool;
}(collection_field_1.ModelMutator));
exports.ModelMutatorFileTool = ModelMutatorFileTool;
var CollectionModelFieldFileTool = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelFieldFileTool, _super);
    function CollectionModelFieldFileTool() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionModelFieldFileTool.isFileToolField = function (f) {
        return f.schema.type === CollectionModelFieldFileTool.TYPE;
    };
    Object.defineProperty(CollectionModelFieldFileTool.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new ModelMutatorFileTool(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldFileTool.prototype, "value", {
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null) {
                return null;
            }
            return this.stateValue.filename;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldFileTool.prototype, "displayValue", {
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null) {
                return null;
            }
            return this.stateValue.filename;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldFileTool.prototype, "attachmentId", {
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null) {
                return null;
            }
            return this.stateValue.attachmentId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldFileTool.prototype, "size", {
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null) {
                return null;
            }
            return this.stateValue.size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelFieldFileTool.prototype, "metadata", {
        get: function () {
            var stateValue = this.stateValue;
            if (stateValue == null) {
                return null;
            }
            return this.stateValue.metadata;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelFieldFileTool.prototype.hasValue = function () {
        var value = this.value;
        if (value == null || value === '') {
            return false;
        }
        return true;
    };
    CollectionModelFieldFileTool.TYPE = core_api_1.IkeFieldType.FILE_TOOL;
    return CollectionModelFieldFileTool;
}(collection_field_1.CollectionModelField));
exports.CollectionModelFieldFileTool = CollectionModelFieldFileTool;
//# sourceMappingURL=file.tool.field.js.map